var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6998 28.35H14.3998L13.6498 26.325H2.32483V7.05002C2.32483 6.15002 3.07483 5.40002 3.97483 5.40002H32.0248C32.9248 5.40002 33.6748 6.15002 33.6748 7.05002V26.4H22.1998L20.6998 28.35ZM15.2248 27.225H20.1748L21.6748 25.2H32.5498V7.05002C32.5498 6.75002 32.3248 6.52502 32.0248 6.52502H3.97483C3.67483 6.52502 3.44983 6.75002 3.44983 7.05002V25.275H14.4748L15.2248 27.225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5999 30.6H5.3999C2.6999 30.6 0.524902 28.425 0.524902 25.725V25.125H14.3999L15.1499 27.15H20.0999L21.5999 25.125H35.3999V25.725C35.4749 28.425 33.2249 30.6 30.5999 30.6ZM1.7249 26.325C2.0249 28.125 3.5249 29.475 5.3999 29.475H30.5249C32.3999 29.475 33.9749 28.125 34.1999 26.325H22.1999L20.6999 28.35H14.3999L13.6499 26.325H1.7249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5249 9.375H6.74988V14.4H12.5249V9.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0499 14.925H6.1499V8.77502H13.0499V14.925ZM7.2749 13.8H11.9249V9.90002H7.2749V13.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5249 17.325H6.74988V22.3499H12.5249V17.325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0499 22.95H6.1499V16.8H13.0499V22.95ZM7.2749 21.825H11.9249V17.925H7.2749V21.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5499 11.25H16.1249V12.375H29.5499V11.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5499 19.275H16.1249V20.4H29.5499V19.275Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.858cf189185498e29c68065f930a24c3.svg";
export { ForwardRef as ReactComponent };